import React from 'react'
import { Result as AntResult } from 'antd'
import styled from 'styled-components'

import { Image } from '../Image'

const StyledResult = styled(AntResult)`
  .ant-result-icon {
    margin: 0 auto;
    max-width: 25%;
  }
`

type Props = {
  title: string
  subTitle: string
  imageSrc: string
  extra: React.ReactNode
}

export const Result: React.FC<Props> = ({ title, subTitle, imageSrc, extra }) => {
  return (
    <StyledResult
      icon={<Image src={imageSrc} width="100%" height="100%" />}
      title={title}
      subTitle={subTitle}
      extra={extra}
    />
  )
}
Result.displayName = 'Result'
